// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_VzSeX {
  padding: 0 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  /* background-color: var(--white-background); */
}

.infoContact_X6JMQ {
  display: flex;
  color: var(--_6-color);
  gap: 10px;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  margin: 20px 0;


  @media (width<=768px) {

    justify-content: center;
  }
  h3,
  p {
    margin: 0;
    color: var(--black-color);
  }
  h3 {
    font-weight: bold;
    font-size: 22px;
  }
  p {
    font-weight: bold;
  }
}
.leftSideTransactions_jBsKq{
  display: flex;
  /* align-items: center; */
  gap: 10px;
  flex-wrap: wrap;
  height: fit-content;
  img{
    height: 130px;
    width: 130px;
    border-radius: 999px;
  }
  .arrowContainer_fxSGs{
    /* height: 100%; */
  }
}
.contactInfo_b5530{
  display: flex;
  flex-direction: column;
  justify-content: center;
  >div{
    display: flex;
    align-items: center;
    gap: 5px;
    flex-wrap: wrap;
  }
}
.iconContainer_FzBls {
  border: none;
  outline: none;
  border-radius: 6px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  -ms-border-radius: 6px;
  -o-border-radius: 6px;
  cursor: pointer;
  border: 1px solid transparent;
  padding: 4px;
  display: flex;
  background-color: var(--_10a37f-background);
  color: var(--white-background);
  align-items: center;
  justify-content: center;
  height: fit-content;
  box-sizing: border-box;
  height: 25px;
  width: 25px;
}
.rightSideTransactions_Wb_05{
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  .btnsContainer_okP1B{
    display: flex;
    align-items: center;
    gap: 10px;
  }
}
.tags_mee8j {
  display: flex;
  gap: 5px;
}

.tag_stDTG {
  text-align: center;
  color: var(--white-background);
  width: fit-content;
  border-radius: 999px;
  height: 20px;
  width: 20px;
  -webkit-border-radius: 999px;
  -moz-border-radius: 999px;
  -ms-border-radius: 999px;
  -o-border-radius: 999px;
  margin-left: -20px;
  cursor: pointer;
}

.tag_stDTG:nth-child(1) {
  margin-left: 0;
}


.tagViolet_XVMNt {
  background-color: var(--d7c5f6-background);
  border: 2px solid var(--a194b7-border);
}
.tagPink_YhXhw {
  background-color: var(--f0c2f2-background);
  border: 2px solid var(--ad8caf-border);
}

.pdfIcon_W9cbQ {
  height: 20px;
  width: 20px;
}

.pagada_Y1Nrv {
  color: var(--009f7a-color);
  font-weight: bold;
  font-size: 15px;
  span {
    margin-right: 5px;
  }
}

.pendiente_TQgNy {
  color: var(--ff9d00-color);
  font-weight: bold;
  font-size: 15px;
  span {
    margin-right: 5px;
  }
}

.incumplida_Kfxe3 {
  color: var(--ff5500-color);
  font-weight: bold;
  font-size: 15px;
  span {
    margin-right: 5px;
  }
}

.vencida_uTLAs {
  color: var(--c5221f-color);
  font-weight: bold;
  font-size: 15px;
  span {
    margin-right: 5px;
  }
}

.anulada_wq6Aj {
  color: var(--8a0300-color);
  font-weight: bold;
  font-size: 15px;
  span {
    margin-right: 5px;
  }
}

.searchContainer_uUdL0 {
  display: flex;
  align-items: center;
  gap: 20px;
  .button_JXn1c {
    text-decoration: underline;
    cursor: pointer;
    color: var(--_2-color);
    min-width: fit-content;
  }
}

.searchInput_HDkkl {
  padding: 10px 35px 10px 40px; 
  border: 1px solid var(--ccc-border);
  border-radius: 10px;
  font-size: 16px;
  outline: none;
  width: 250px;
}

.searchInput_HDkkl::placeholder {
  color: var(--aaa-color);
}



.infoBtn_Ii3m2 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background-color: var(--_233f39-color);
  color: var(--white-background);
  border: none;
  padding: 10px;
  cursor: pointer;
  font-size: 16px;
  border-radius: 15px;
  -webkit-border-radius: 15px;
  -moz-border-radius: 15px;
  -ms-border-radius: 15px;
  -o-border-radius: 15px;
  img {
    width: 15px;
    height: 15px;
  }
}
.addButton_b9ZzP {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 40px;
  width: 40px;
  background-color: var(--_233f39-color);
  color: var(--white-background);
  border: none;
  cursor: pointer;
  font-size: 16px;
  border-radius: 7px;
  -webkit-border-radius: 7px;
  -moz-border-radius: 7px;
  -ms-border-radius: 7px;
  -o-border-radius: 7px;
  img {
    width: 15px;
    height: 15px;
  }
}
.addButton_b9ZzP:hover {
  background-color: var(--_122521-background);
}




.table_aWFsp {
  text-align: start;
  border-collapse: collapse; 
  thead {
    background-color: var(--f5-background);
  }
}

.name_WECBF {
  color: var(--_3-color);
  font-weight: 600;
}
.table_aWFsp {
  tbody {
    p {
      margin: 0;
    }
    tr {
      border-top: 1px solid var(--eaecf0-border);
      border-bottom: 1px solid var(--eaecf0-border);
      height: 20px;
    }
  }
  th {
    text-align: start;
    padding: 10px; 
    font-weight: 500; 
    width: 150px; 
    color: var(--_6-color);
  }

  td {
    padding: 10px; 
    color: var(--_6-color);
    font-size: 13px;
    height: 20px;
    p {
      margin: 0;
    }
  }

  thead th {
    min-width: 120px; 
  }

  .small_VqQ_D {
    min-width: 40px;
    width: 40px;
  }
  td p:first-of-type {
    margin-bottom: 0;
    display: flex;
    align-items: center;
    gap: 5px;
  }
}
.actions_bNsme {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  img {
    cursor: pointer;
  }
}
.idContainer_pnP45{
  display: flex;
  align-items: center;
  gap: 5px;
  p {
    white-space: nowrap;           
    overflow: hidden;              
    text-overflow: ellipsis;       
    max-width: 100px;              
    display: inline-block;        
  }


}
.transacciones_yy037 {
  display: flex;
  flex-direction: column;
  gap: 3px;
  width: 100px;
  a {
    font-weight: bold;
  }
  a,
  span {
    color: var(--_073f31-color);
  }
}

input[type="checkbox"] {
  width: 15px;
  height: 15px;
  accent-color: var(--_10a37f-background);
}

.bg_IxbFf {
  background-color: var(--_00000020-background);
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
}
.billContainer_ZXMjP::-webkit-scrollbar {
  display: none;
}
.billContainer_ZXMjP {
  position: fixed;
  background-color: var(--white-background);
  padding-bottom: 20px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(1);
  height: 80vh;
  width: 50%;
  padding-bottom: 20px;
  overflow-y: scroll;
  border-radius: 10px;

  -webkit-transform: translate(-50%, -50%) scale(1);
  -moz-transform: translate(-50%, -50%) scale(1);
  -ms-transform: translate(-50%, -50%) scale(1);
  -o-transform: translate(-50%, -50%) scale(1);
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
  animation: scaleUp_cL7pW 300ms ease-out forwards;
  -webkit-animation: scaleUp_cL7pW 300ms ease-out forwards;
}





.inputWrapper_Gil8M {
  position: relative;
  display: flex;
  align-items: center;
  height: 100%;
}



.row_CuQ4l {
  display: flex;
  justify-content: space-between;
  align-items: center;
  p {
    margin: 0;
  }
}





.logoCorporativo_zYiMv {
  display: flex;
  margin-top: 15px;
  flex-direction: column;
  flex: 1 1;
  gap: 10px;
  button {
    background-color: var(--white-background);
    padding: 7px;
    border: 1px solid var(--ced4da-border);
    border-radius: 6px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
  }

}

.deleteContainer_RgtJx {
  display: flex;
  align-items: center;
  gap: 10px;
}
.delete_q0pnX {
  position: absolute;
  height: 20px;
  width: 20px;
  top: -7px;
  right: -7px;
  background-color: var(--dc3545-background);
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  font-size: 20px;
  color: var(--white-background);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

input[type="radio"] {
  box-sizing: border-box;
  appearance: none;
  width: 18px;
  height: 18px;
  border: 1px solid var(--B3B3B3-border);
  border-radius: 50%;
  background-color: var(--f9-background);
  cursor: pointer;
  transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -ms-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  padding: 5px;
}
input[type="radio"]:checked {
  border-color: var(--C11515-color);
  background-color: var(--white-background);
  border: 4px solid var(--black-color);
}



.articleBill_p9fjJ {
  display: flex;
  flex-direction: column;
  gap: 10px;
  img {
    height: 40px;
    width: 40px;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
  }
  .articleTitle_B0Odr {
    display: flex;
    justify-content: space-between;
    span {
      color: var(--92959865-color);
    }
    a {
      color: var(--black-color);
    }
  }

  .articleBody_iddnO {
    display: flex;
    gap: 20px;
    align-items: center;
    .info_GmSOo {
      width: 100%;
      display: flex;
      flex-direction: column;
      div {
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding-right: 50px;
        box-sizing: border-box;
      }
    }
  }
}
.light_tygSv {
  color: var(--_71717a-color);
}



.scaleDown_iaC2v {
  animation: scaleDown_iaC2v 300ms ease-in forwards;
  -webkit-animation: scaleDown_iaC2v 300ms ease-in forwards;
}

@keyframes scaleUp_cL7pW {
  from {
    transform: translate(-50%, -50%) scale(0);
    -webkit-transform: translate(-50%, -50%) scale(0);
    -moz-transform: translate(-50%, -50%) scale(0);
    -ms-transform: translate(-50%, -50%) scale(0);
    -o-transform: translate(-50%, -50%) scale(0);
  }
  to {
    transform: translate(-50%, -50%) scale(1);
    -webkit-transform: translate(-50%, -50%) scale(1);
    -moz-transform: translate(-50%, -50%) scale(1);
    -ms-transform: translate(-50%, -50%) scale(1);
    -o-transform: translate(-50%, -50%) scale(1);
  }
}

@keyframes scaleDown_iaC2v {
  from {
    transform: translate(-50%, -50%) scale(1);
  }
  to {
    transform: translate(-50%, -50%) scale(0);
  }
}

.fadeOut_fSyV3 {
  opacity: 0;
}


.searchIconsWrappers_IRWio {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  background: var(--ececf1-background);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border-radius: 3px;
}
.optionsPopupContainer_ifAUv {
  position: absolute;
  z-index: 9999;
  bottom: 0px;
  left: 35px;
}
.edit_Akbj6 {
  position: relative;
  display: flex;
  gap: 10px;
  align-items: end;
  opacity: 0;
  a {
    color: var(--_073f31-color);
  }
  .dotsOptions_tTfzw {
    cursor: pointer;
    transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    -o-transform: rotate(90deg);
    img {
      width: 18px;
      height: 18px;
    }
  }
}
.inputWrapperHover_wzkzj {
  position: relative;
  height: 28px;
  min-width: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.inputWrapperHover_wzkzj:hover{
  .inputContainer_bXPOY {
    opacity: 1;
  }
}

.inputContainer_bXPOY {
  background-color: var(--_52525261-background);
  transition: all 300ms;
  width:25px;
  border-radius: 999px;
  height:25px;

  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 300ms;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
}
.optionsTd_qWPVw{
  display: flex;
  flex-direction: row-reverse;
}

.optionsTr_AYh6V{
}

.optionsTr_AYh6V:hover {
  transform: scale(1.01);
  transition: all 0.3s ease;
  box-shadow:
    inset 0 6px 10px -6px color-mix(in srgb, var(--_10a37f-background) 20%, transparent),
    inset 0 -6px 10px -6px color-mix(in srgb, var(--_10a37f-background) 20%, transparent);
}


.optionsTr_AYh6V:hover{
  .optionsTd_qWPVw{
    .edit_Akbj6{
      opacity: 1;
    }
  }
}


.mainContainer_zoI0E{
  display: grid;
  grid-template-columns: 3fr 0px;
  transition: grid-template-columns 1.9s ease;
  width: 100%;
  height: 100%;
}

.sectionTableMore_BGIxA {
grid-template-columns: 3fr 350px;
}

.popupContainer_fR9Bk{
  overflow: hidden;
  transform: translateX(100%);
  opacity: 0;
  transition: transform 1.9s ease, opacity 1.9s ease;
}

.popupContainerVisible_CebAz  {
  transform: translateX(0);
  opacity: 1;
}


.btnContactInfoContainer_AZujN{
  display: flex;
  align-items: center;
  gap: 5px;
  width: 100%;
  justify-content: center;
  pointer-events: auto;
  button{
    border-radius: 999px;
    svg{
      color: var(--969595-fill);
      fill: var(--969595-fill);
    }
    .activeBtn__6Z0v{
      color: var(--_10a37f-border);
      fill: var(--_10a37f-border);
    }
  }
  svg{
    width: 20px;
    height: 20px;
  }
}

.selectedTagsContainer_NFTAN{
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 10px 0;
}

.selectedTags_RxPOb{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  width: fit-content;
  border-radius: 8px;
  gap: 15px;
  font-size: 18px;
}

.searchPaginationContainer_lOukS{
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  margin: 10px 0;
}

.iconsContainer_uaCu7{
  display: flex;
  align-items: center;
  gap: 5px;
  .iconWrapper_zlQtd{
    border: 1px solid #CBCBCB;
    height: 30px;
    width: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 999px;
svg{
  width: 20px;
  height: 20px;
  fill: var(--_3-color);
  color: var(--_3-color);
}
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/Transactions/Transactions.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,cAAc;;;EAGd;;IAEE,uBAAuB;EACzB;EACA;;IAEE,SAAS;IACT,yBAAyB;EAC3B;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB;IACE,aAAa;IACb,YAAY;IACZ,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;EACjB;AACF;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,2CAA2C;EAC3C,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;AACF;AACA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,0CAA0C;EAC1C,sCAAsC;AACxC;AACA;EACE,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT;IACE,0BAA0B;IAC1B,eAAe;IACf,sBAAsB;IACtB,sBAAsB;EACxB;AACF;;AAEA;EACE,4BAA4B;EAC5B,mCAAmC;EACnC,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;;;AAIA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,sCAAsC;EACtC,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,sCAAsC;EACtC,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE,2CAA2C;AAC7C;;;;;AAKA;EACE,iBAAiB;EACjB,yBAAyB;EACzB;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE;IACE;MACE,SAAS;IACX;IACA;MACE,0CAA0C;MAC1C,6CAA6C;MAC7C,YAAY;IACd;EACF;EACA;IACE,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ;MACE,SAAS;IACX;EACF;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;AACF;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT;IACE,eAAe;EACjB;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR;IACE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,qBAAqB;EACvB;;;AAGF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ;IACE,iBAAiB;EACnB;EACA;;IAEE,2BAA2B;EAC7B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,6CAA6C;EAC7C,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,yCAAyC;EACzC,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,yCAAyC;EACzC,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;;EAEnB,iDAAiD;EACjD,8CAA8C;EAC9C,6CAA6C;EAC7C,4CAA4C;EAC5C,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,gDAA0C;EAC1C,wDAAkD;AACpD;;;;;;AAMA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;;;AAIA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB;IACE,SAAS;EACX;AACF;;;;;;AAMA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,SAAO;EACP,SAAS;EACT;IACE,yCAAyC;IACzC,YAAY;IACZ,sCAAsC;IACtC,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;EACvB;;AAEF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;EACf,yBAAyB;EACzB,iCAAiC;EACjC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,YAAY;AACd;AACA;EACE,iCAAiC;EACjC,yCAAyC;EACzC,oCAAoC;AACtC;;;;AAIA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;EACvB;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B;MACE,4BAA4B;IAC9B;IACA;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB;MACE,WAAW;MACX,aAAa;MACb,sBAAsB;MACtB;QACE,WAAW;QACX,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,sBAAsB;MACxB;IACF;EACF;AACF;AACA;EACE,2BAA2B;AAC7B;;;;AAIA;EACE,iDAA2C;EAC3C,yDAAmD;AACrD;;AAEA;EACE;IACE,yCAAyC;IACzC,iDAAiD;IACjD,8CAA8C;IAC9C,6CAA6C;IAC7C,4CAA4C;EAC9C;EACA;IACE,yCAAyC;IACzC,iDAAiD;IACjD,8CAA8C;IAC9C,6CAA6C;IAC7C,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,yCAAyC;EAC3C;EACA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE,UAAU;AACZ;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV;IACE,2BAA2B;EAC7B;EACA;IACE,eAAe;IACf,wBAAwB;IACxB,gCAAgC;IAChC,6BAA6B;IAC7B,4BAA4B;IAC5B,2BAA2B;IAC3B;MACE,WAAW;MACX,YAAY;IACd;EACF;AACF;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,6CAA6C;EAC7C,qBAAqB;EACrB,UAAU;EACV,oBAAoB;EACpB,WAAW;;EAEX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;AACZ;AACA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;AACA;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB;;yFAEuF;AACzF;;;AAGA;EACE;IACE;MACE,UAAU;IACZ;EACF;AACF;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,2CAA2C;EAC3C,WAAW;EACX,YAAY;AACd;;AAEA;AACA,gCAAgC;AAChC;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,UAAU;EACV,kDAAkD;AACpD;;AAEA;EACE,wBAAwB;EACxB,UAAU;AACZ;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,uBAAuB;EACvB,oBAAoB;EACpB;IACE,oBAAoB;IACpB;MACE,yBAAyB;MACzB,wBAAwB;IAC1B;IACA;MACE,4BAA4B;MAC5B,2BAA2B;IAC7B;EACF;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR;IACE,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;AACxB;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;AACxB;EACE;AACF","sourcesContent":[".container {\n  padding: 0 10px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  box-sizing: border-box;\n  /* background-color: var(--white-background); */\n}\n\n.infoContact {\n  display: flex;\n  color: var(--_6-color);\n  gap: 10px;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  width: 100%;\n  margin: 20px 0;\n\n\n  @media (width<=768px) {\n\n    justify-content: center;\n  }\n  h3,\n  p {\n    margin: 0;\n    color: var(--black-color);\n  }\n  h3 {\n    font-weight: bold;\n    font-size: 22px;\n  }\n  p {\n    font-weight: bold;\n  }\n}\n.leftSideTransactions{\n  display: flex;\n  /* align-items: center; */\n  gap: 10px;\n  flex-wrap: wrap;\n  height: fit-content;\n  img{\n    height: 130px;\n    width: 130px;\n    border-radius: 999px;\n  }\n  .arrowContainer{\n    /* height: 100%; */\n  }\n}\n.contactInfo{\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  >div{\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    flex-wrap: wrap;\n  }\n}\n.iconContainer {\n  border: none;\n  outline: none;\n  border-radius: 6px;\n  -webkit-border-radius: 6px;\n  -moz-border-radius: 6px;\n  -ms-border-radius: 6px;\n  -o-border-radius: 6px;\n  cursor: pointer;\n  border: 1px solid transparent;\n  padding: 4px;\n  display: flex;\n  background-color: var(--_10a37f-background);\n  color: var(--white-background);\n  align-items: center;\n  justify-content: center;\n  height: fit-content;\n  box-sizing: border-box;\n  height: 25px;\n  width: 25px;\n}\n.rightSideTransactions{\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  gap: 10px;\n  .btnsContainer{\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n}\n.tags {\n  display: flex;\n  gap: 5px;\n}\n\n.tag {\n  text-align: center;\n  color: var(--white-background);\n  width: fit-content;\n  border-radius: 999px;\n  height: 20px;\n  width: 20px;\n  -webkit-border-radius: 999px;\n  -moz-border-radius: 999px;\n  -ms-border-radius: 999px;\n  -o-border-radius: 999px;\n  margin-left: -20px;\n  cursor: pointer;\n}\n\n.tag:nth-child(1) {\n  margin-left: 0;\n}\n\n\n.tagViolet {\n  background-color: var(--d7c5f6-background);\n  border: 2px solid var(--a194b7-border);\n}\n.tagPink {\n  background-color: var(--f0c2f2-background);\n  border: 2px solid var(--ad8caf-border);\n}\n\n.pdfIcon {\n  height: 20px;\n  width: 20px;\n}\n\n.pagada {\n  color: var(--009f7a-color);\n  font-weight: bold;\n  font-size: 15px;\n  span {\n    margin-right: 5px;\n  }\n}\n\n.pendiente {\n  color: var(--ff9d00-color);\n  font-weight: bold;\n  font-size: 15px;\n  span {\n    margin-right: 5px;\n  }\n}\n\n.incumplida {\n  color: var(--ff5500-color);\n  font-weight: bold;\n  font-size: 15px;\n  span {\n    margin-right: 5px;\n  }\n}\n\n.vencida {\n  color: var(--c5221f-color);\n  font-weight: bold;\n  font-size: 15px;\n  span {\n    margin-right: 5px;\n  }\n}\n\n.anulada {\n  color: var(--8a0300-color);\n  font-weight: bold;\n  font-size: 15px;\n  span {\n    margin-right: 5px;\n  }\n}\n\n.searchContainer {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  .button {\n    text-decoration: underline;\n    cursor: pointer;\n    color: var(--_2-color);\n    min-width: fit-content;\n  }\n}\n\n.searchInput {\n  padding: 10px 35px 10px 40px; \n  border: 1px solid var(--ccc-border);\n  border-radius: 10px;\n  font-size: 16px;\n  outline: none;\n  width: 250px;\n}\n\n.searchInput::placeholder {\n  color: var(--aaa-color);\n}\n\n\n\n.infoBtn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  background-color: var(--_233f39-color);\n  color: var(--white-background);\n  border: none;\n  padding: 10px;\n  cursor: pointer;\n  font-size: 16px;\n  border-radius: 15px;\n  -webkit-border-radius: 15px;\n  -moz-border-radius: 15px;\n  -ms-border-radius: 15px;\n  -o-border-radius: 15px;\n  img {\n    width: 15px;\n    height: 15px;\n  }\n}\n.addButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  height: 40px;\n  width: 40px;\n  background-color: var(--_233f39-color);\n  color: var(--white-background);\n  border: none;\n  cursor: pointer;\n  font-size: 16px;\n  border-radius: 7px;\n  -webkit-border-radius: 7px;\n  -moz-border-radius: 7px;\n  -ms-border-radius: 7px;\n  -o-border-radius: 7px;\n  img {\n    width: 15px;\n    height: 15px;\n  }\n}\n.addButton:hover {\n  background-color: var(--_122521-background);\n}\n\n\n\n\n.table {\n  text-align: start;\n  border-collapse: collapse; \n  thead {\n    background-color: var(--f5-background);\n  }\n}\n\n.name {\n  color: var(--_3-color);\n  font-weight: 600;\n}\n.table {\n  tbody {\n    p {\n      margin: 0;\n    }\n    tr {\n      border-top: 1px solid var(--eaecf0-border);\n      border-bottom: 1px solid var(--eaecf0-border);\n      height: 20px;\n    }\n  }\n  th {\n    text-align: start;\n    padding: 10px; \n    font-weight: 500; \n    width: 150px; \n    color: var(--_6-color);\n  }\n\n  td {\n    padding: 10px; \n    color: var(--_6-color);\n    font-size: 13px;\n    height: 20px;\n    p {\n      margin: 0;\n    }\n  }\n\n  thead th {\n    min-width: 120px; \n  }\n\n  .small {\n    min-width: 40px;\n    width: 40px;\n  }\n  td p:first-of-type {\n    margin-bottom: 0;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n  }\n}\n.actions {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  img {\n    cursor: pointer;\n  }\n}\n.idContainer{\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  p {\n    white-space: nowrap;           \n    overflow: hidden;              \n    text-overflow: ellipsis;       \n    max-width: 100px;              \n    display: inline-block;        \n  }\n\n\n}\n.transacciones {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  width: 100px;\n  a {\n    font-weight: bold;\n  }\n  a,\n  span {\n    color: var(--_073f31-color);\n  }\n}\n\ninput[type=\"checkbox\"] {\n  width: 15px;\n  height: 15px;\n  accent-color: var(--_10a37f-background);\n}\n\n.bg {\n  background-color: var(--_00000020-background);\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.billContainer::-webkit-scrollbar {\n  display: none;\n}\n.billContainer {\n  position: fixed;\n  background-color: var(--white-background);\n  padding-bottom: 20px;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%) scale(1);\n  height: 80vh;\n  width: 50%;\n  padding-bottom: 20px;\n  overflow-y: scroll;\n  border-radius: 10px;\n\n  -webkit-transform: translate(-50%, -50%) scale(1);\n  -moz-transform: translate(-50%, -50%) scale(1);\n  -ms-transform: translate(-50%, -50%) scale(1);\n  -o-transform: translate(-50%, -50%) scale(1);\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  -ms-border-radius: 10px;\n  -o-border-radius: 10px;\n  animation: scaleUp 300ms ease-out forwards;\n  -webkit-animation: scaleUp 300ms ease-out forwards;\n}\n\n\n\n\n\n.inputWrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  height: 100%;\n}\n\n\n\n.row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  p {\n    margin: 0;\n  }\n}\n\n\n\n\n\n.logoCorporativo {\n  display: flex;\n  margin-top: 15px;\n  flex-direction: column;\n  flex: 1;\n  gap: 10px;\n  button {\n    background-color: var(--white-background);\n    padding: 7px;\n    border: 1px solid var(--ced4da-border);\n    border-radius: 6px;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n  }\n\n}\n\n.deleteContainer {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.delete {\n  position: absolute;\n  height: 20px;\n  width: 20px;\n  top: -7px;\n  right: -7px;\n  background-color: var(--dc3545-background);\n  border-radius: 50%;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  -ms-border-radius: 50%;\n  -o-border-radius: 50%;\n  font-size: 20px;\n  color: var(--white-background);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\ninput[type=\"radio\"] {\n  box-sizing: border-box;\n  appearance: none;\n  width: 18px;\n  height: 18px;\n  border: 1px solid var(--B3B3B3-border);\n  border-radius: 50%;\n  background-color: var(--f9-background);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  -webkit-transition: all 0.3s ease;\n  -moz-transition: all 0.3s ease;\n  -ms-transition: all 0.3s ease;\n  -o-transition: all 0.3s ease;\n  padding: 5px;\n}\ninput[type=\"radio\"]:checked {\n  border-color: var(--C11515-color);\n  background-color: var(--white-background);\n  border: 4px solid var(--black-color);\n}\n\n\n\n.articleBill {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  img {\n    height: 40px;\n    width: 40px;\n    border-radius: 50%;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n  }\n  .articleTitle {\n    display: flex;\n    justify-content: space-between;\n    span {\n      color: var(--92959865-color);\n    }\n    a {\n      color: var(--black-color);\n    }\n  }\n\n  .articleBody {\n    display: flex;\n    gap: 20px;\n    align-items: center;\n    .info {\n      width: 100%;\n      display: flex;\n      flex-direction: column;\n      div {\n        width: 100%;\n        display: flex;\n        justify-content: space-between;\n        padding-right: 50px;\n        box-sizing: border-box;\n      }\n    }\n  }\n}\n.light {\n  color: var(--_71717a-color);\n}\n\n\n\n.scaleDown {\n  animation: scaleDown 300ms ease-in forwards;\n  -webkit-animation: scaleDown 300ms ease-in forwards;\n}\n\n@keyframes scaleUp {\n  from {\n    transform: translate(-50%, -50%) scale(0);\n    -webkit-transform: translate(-50%, -50%) scale(0);\n    -moz-transform: translate(-50%, -50%) scale(0);\n    -ms-transform: translate(-50%, -50%) scale(0);\n    -o-transform: translate(-50%, -50%) scale(0);\n  }\n  to {\n    transform: translate(-50%, -50%) scale(1);\n    -webkit-transform: translate(-50%, -50%) scale(1);\n    -moz-transform: translate(-50%, -50%) scale(1);\n    -ms-transform: translate(-50%, -50%) scale(1);\n    -o-transform: translate(-50%, -50%) scale(1);\n  }\n}\n\n@keyframes scaleDown {\n  from {\n    transform: translate(-50%, -50%) scale(1);\n  }\n  to {\n    transform: translate(-50%, -50%) scale(0);\n  }\n}\n\n.fadeOut {\n  opacity: 0;\n}\n\n\n.searchIconsWrappers {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  background: var(--ececf1-background);\n  cursor: pointer;\n  user-select: none;\n  border-radius: 3px;\n}\n.optionsPopupContainer {\n  position: absolute;\n  z-index: 9999;\n  bottom: 0px;\n  left: 35px;\n}\n.edit {\n  position: relative;\n  display: flex;\n  gap: 10px;\n  align-items: end;\n  opacity: 0;\n  a {\n    color: var(--_073f31-color);\n  }\n  .dotsOptions {\n    cursor: pointer;\n    transform: rotate(90deg);\n    -webkit-transform: rotate(90deg);\n    -moz-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    -o-transform: rotate(90deg);\n    img {\n      width: 18px;\n      height: 18px;\n    }\n  }\n}\n.inputWrapperHover {\n  position: relative;\n  height: 28px;\n  min-width: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.inputWrapperHover:hover{\n  .inputContainer {\n    opacity: 1;\n  }\n}\n\n.inputContainer {\n  background-color: var(--_52525261-background);\n  transition: all 300ms;\n  width:25px;\n  border-radius: 999px;\n  height:25px;\n\n  padding: 2px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 300ms;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  opacity: 0;\n}\n.optionsTd{\n  display: flex;\n  flex-direction: row-reverse;\n}\n\n.optionsTr{\n}\n\n.optionsTr:hover {\n  transform: scale(1.01);\n  transition: all 0.3s ease;\n  box-shadow:\n    inset 0 6px 10px -6px color-mix(in srgb, var(--_10a37f-background) 20%, transparent),\n    inset 0 -6px 10px -6px color-mix(in srgb, var(--_10a37f-background) 20%, transparent);\n}\n\n\n.optionsTr:hover{\n  .optionsTd{\n    .edit{\n      opacity: 1;\n    }\n  }\n}\n\n\n.mainContainer{\n  display: grid;\n  grid-template-columns: 3fr 0px;\n  transition: grid-template-columns 1.9s ease;\n  width: 100%;\n  height: 100%;\n}\n\n.sectionTableMore {\ngrid-template-columns: 3fr 350px;\n}\n\n.popupContainer{\n  overflow: hidden;\n  transform: translateX(100%);\n  opacity: 0;\n  transition: transform 1.9s ease, opacity 1.9s ease;\n}\n\n.popupContainerVisible  {\n  transform: translateX(0);\n  opacity: 1;\n}\n\n\n.btnContactInfoContainer{\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  width: 100%;\n  justify-content: center;\n  pointer-events: auto;\n  button{\n    border-radius: 999px;\n    svg{\n      color: var(--969595-fill);\n      fill: var(--969595-fill);\n    }\n    .activeBtn{\n      color: var(--_10a37f-border);\n      fill: var(--_10a37f-border);\n    }\n  }\n  svg{\n    width: 20px;\n    height: 20px;\n  }\n}\n\n.selectedTagsContainer{\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin: 10px 0;\n}\n\n.selectedTags{\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 24px;\n  width: fit-content;\n  border-radius: 8px;\n  gap: 15px;\n  font-size: 18px;\n}\n\n.searchPaginationContainer{\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  margin: 10px 0;\n}\n\n.iconsContainer{\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  .iconWrapper{\n    border: 1px solid #CBCBCB;\n    height: 30px;\n    width: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 999px;\nsvg{\n  width: 20px;\n  height: 20px;\n  fill: var(--_3-color);\n  color: var(--_3-color);\n}\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_VzSeX`,
	"infoContact": `infoContact_X6JMQ`,
	"leftSideTransactions": `leftSideTransactions_jBsKq`,
	"arrowContainer": `arrowContainer_fxSGs`,
	"contactInfo": `contactInfo_b5530`,
	"iconContainer": `iconContainer_FzBls`,
	"rightSideTransactions": `rightSideTransactions_Wb_05`,
	"btnsContainer": `btnsContainer_okP1B`,
	"tags": `tags_mee8j`,
	"tag": `tag_stDTG`,
	"tagViolet": `tagViolet_XVMNt`,
	"tagPink": `tagPink_YhXhw`,
	"pdfIcon": `pdfIcon_W9cbQ`,
	"pagada": `pagada_Y1Nrv`,
	"pendiente": `pendiente_TQgNy`,
	"incumplida": `incumplida_Kfxe3`,
	"vencida": `vencida_uTLAs`,
	"anulada": `anulada_wq6Aj`,
	"searchContainer": `searchContainer_uUdL0`,
	"button": `button_JXn1c`,
	"searchInput": `searchInput_HDkkl`,
	"infoBtn": `infoBtn_Ii3m2`,
	"addButton": `addButton_b9ZzP`,
	"table": `table_aWFsp`,
	"name": `name_WECBF`,
	"small": `small_VqQ_D`,
	"actions": `actions_bNsme`,
	"idContainer": `idContainer_pnP45`,
	"transacciones": `transacciones_yy037`,
	"bg": `bg_IxbFf`,
	"billContainer": `billContainer_ZXMjP`,
	"scaleUp": `scaleUp_cL7pW`,
	"inputWrapper": `inputWrapper_Gil8M`,
	"row": `row_CuQ4l`,
	"logoCorporativo": `logoCorporativo_zYiMv`,
	"deleteContainer": `deleteContainer_RgtJx`,
	"delete": `delete_q0pnX`,
	"articleBill": `articleBill_p9fjJ`,
	"articleTitle": `articleTitle_B0Odr`,
	"articleBody": `articleBody_iddnO`,
	"info": `info_GmSOo`,
	"light": `light_tygSv`,
	"scaleDown": `scaleDown_iaC2v`,
	"fadeOut": `fadeOut_fSyV3`,
	"searchIconsWrappers": `searchIconsWrappers_IRWio`,
	"optionsPopupContainer": `optionsPopupContainer_ifAUv`,
	"edit": `edit_Akbj6`,
	"dotsOptions": `dotsOptions_tTfzw`,
	"inputWrapperHover": `inputWrapperHover_wzkzj`,
	"inputContainer": `inputContainer_bXPOY`,
	"optionsTd": `optionsTd_qWPVw`,
	"optionsTr": `optionsTr_AYh6V`,
	"mainContainer": `mainContainer_zoI0E`,
	"sectionTableMore": `sectionTableMore_BGIxA`,
	"popupContainer": `popupContainer_fR9Bk`,
	"popupContainerVisible": `popupContainerVisible_CebAz`,
	"btnContactInfoContainer": `btnContactInfoContainer_AZujN`,
	"activeBtn": `activeBtn__6Z0v`,
	"selectedTagsContainer": `selectedTagsContainer_NFTAN`,
	"selectedTags": `selectedTags_RxPOb`,
	"searchPaginationContainer": `searchPaginationContainer_lOukS`,
	"iconsContainer": `iconsContainer_uaCu7`,
	"iconWrapper": `iconWrapper_zlQtd`
};
export default ___CSS_LOADER_EXPORT___;
